export default {
  locationDefects: [],
  ticketDefects: [],
  loading: false
}
